import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';

const FeatureGroupItem = ({ icon , link  })=>/*#__PURE__*/ React.createElement("li", {
        className: "feature-group-item"
    }, /*#__PURE__*/ React.createElement("a", {
        href: link.href,
        className: "feature-group-item__box"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "feature-group-item__imagebox"
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "feature-group-item__icon",
        name: icon
    })), link.label && /*#__PURE__*/ React.createElement("span", {
        className: "feature-group-item__title"
    }, link.label)))
;
const FeatureGroup = ({ items  })=>{
    if (!items) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "feature-group"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "site-container"
    }, /*#__PURE__*/ React.createElement("ul", {
        className: "feature-group__list"
    }, items && items.map((item)=>/*#__PURE__*/ React.createElement(FeatureGroupItem, swcHelpers.extends({
            key: item.id
        }, item))
    ))));
};

export { FeatureGroup as default };
//# sourceMappingURL=FeatureGroup.js.map
